import { TypeAheadUserGroups, UserGroupLight } from 'phoenix/domain/phoenix-user-group';
import { PhoenixToggleService } from 'phoenix/services/phoenixToggleService';
export interface IUserGroupsService {
	getUserGroupsTypeAhead(filter?:string, systemName?: string): ng.IPromise<UserGroupLight[]>;
}

/**
* @ngdoc service
* @name  sharebase.sbUserGroupsService
* 
* @description 
* A service used to retrieve ShareBase user groups
**/
export function UserGroupsServiceFactory(
	$http, 
	pxUriPathService, 
	pxPhoenixToggleService:PhoenixToggleService
) {
	let sharingEndpointsPromise:ng.IPromise<any>;

	return {
		/**
		* @ngdoc method
		* @name sbUserGroupsService#getUserGroups
		* @methodOf sharebase.sbUserGroupsService
		* @kind function
		*
		* @description
		* Gets a collection of user groups
		*
		* @returns {Deferred} A promise that will resolve with a collection of user groups
		* 
		*/
		getUserGroups,
		getUserGroupsTypeAhead
	};

	function getSharingEndpoints(systemName?: string){
		if(sharingEndpointsPromise){
			return sharingEndpointsPromise;
		}

		let opts: any = { };
		if (systemName) {
			opts.system = systemName;
		}

		sharingEndpointsPromise = pxPhoenixToggleService.isEnabled('system-sharing-endpoint')
			.then(isEnabled => {
				let path = isEnabled ? '/{system}/sharing' : '/sharing';
				let uri = pxUriPathService.resolvePath(path);
				return $http.get(uri)
					.then(response => response.data);
			});

		return sharingEndpointsPromise;
	}

	function getUserGroups(systemName) {
		return $http.get(pxUriPathService.resolvePath('/{system}/usergroups', {
			system: systemName
		}))
		.then(function (response) {
			return response.data;
		});
	}

	function getUserGroupsTypeAhead(filter, systemName?: string){
		return getSharingEndpoints(systemName)
			.then(sharingEndpoints => {
				let uri = sharingEndpoints.Links.UsersAndGroupsSuggestionsUri;
				uri = pxUriPathService.resolvePath(uri, {
					filter,
					includeGroups: true,
					includeUsers: false
				});

				return $http.get(uri);
			})
			.then(response => (response.data as TypeAheadUserGroups).UserGroups);
	}
}

UserGroupsServiceFactory.$inject = [
	'$http',
	'pxUriPathService',
	'pxPhoenixToggleService'
];


// WEBPACK FOOTER //
// ./src/sharebase/services/userGroupsService.ts